export default class QueryParser {
  static queryToBoolean(
    param: string | (string | null)[] | undefined,
    defaultValue?: boolean
  ): boolean | undefined {
    if (param === "1") {
      return true;
    }
    if (param === "0") {
      return false;
    }

    return defaultValue;
  }
}
